import { stripMarketingParamsFromUrl } from './applyToUrl'
import { clear } from './store'

let hasFlushed = false

/**
 * Mark the flush as complete: strip the persisted marketing params from the URL
 * and clear the in-memory snapshot so they're never re-appended. Called after a
 * successful booking POST so attribution survives retries on failure. Idempotent.
 */
export function completeMarketingFlush(): void {
  if (hasFlushed) {
    return
  }

  hasFlushed = true
  stripMarketingParamsFromUrl()
  clear()
}

/** True once the post-booking flush has happened. */
export function hasMarketingFlushed(): boolean {
  return hasFlushed
}

/** Test-only reset helper. */
export function __resetFlushForTests(): void {
  hasFlushed = false
}
